// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"74":"60330189","732":"a88db962","977":"88914751"}[chunkId] + ".chunk.js");